import React from 'react';


const atividades = ['Criacao', 'Evolução', 'Conclusão Sindicante', 'Conclusão Fraude', 'Conclusão Sinistro', 'Parecer Juridico', 'Reabertura']

export default function NotificacoesConfig() {


  return (
    <div className='container-box'>
      <h5>Notificações</h5>
      <span className='title-describe'>Gerencie as notificações que deseja receber.</span>
      <hr />
      <div className="col-md-12">
        <table id='table-notificacoes'>
          <thead>
            <tr>
              <th>Atividade</th>
              <th>SMS</th>
              <th>E-mail</th>
              <th>Whatsapp</th>
              <th>Todos</th>
            </tr>
          </thead>
          <tbody>
            {atividades.map(atividade =>
              <tr>
                <td>{atividade}</td>
                <td>
                  <div className="toggle">
                    <input type="checkbox" id={`${atividade}_SMS`} />
                    <label htmlFor={`${atividade}_SMS`}></label>
                  </div>
                </td>
                <td>
                  <div className="toggle">
                    <input type="checkbox" id={`${atividade}_email`} />
                    <label htmlFor={`${atividade}_email`}></label>
                  </div>
                </td>
                <td>
                  <div className="toggle">
                    <input type="checkbox" id={`${atividade}_Whatsapp`} />
                    <label htmlFor={`${atividade}_Whatsapp`}></label>
                  </div>
                </td>
                <td>
                  <div className="toggle">
                    <input type="checkbox" id={`${atividade}_todos`} />
                    <label htmlFor={`${atividade}_todos`}></label>
                  </div>
                </td>
              </tr>
            )}

          </tbody>
        </table>


      </div>
    </div>
  )
}
